import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-gutter-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_items_loader = _resolveComponent("async-items-loader")!
  const _component_edit_payment_method_btn = _resolveComponent("edit-payment-method-btn")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_delete_payment_method_btn = _resolveComponent("delete-payment-method-btn")!
  const _component_payment_method_item = _resolveComponent("payment-method-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_ctx.isGranted('VIEW_PAYMENT_METHODS'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_async_items_loader, {
          task: _ctx.task,
          "num-items": _ctx.items.length
        }, {
          default: _withCtx(() => [
            _createTextVNode(" No payment methods found. ")
          ]),
          _: 1
        }, 8, ["task", "num-items"]),
        (_ctx.items.length)
          ? (_openBlock(), _createBlock(_component_q_list, {
              key: 0,
              bordered: "",
              separator: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                  return (_openBlock(), _createBlock(_component_payment_method_item, {
                    key: item.id,
                    "payment-method": item,
                    clickable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_edit_payment_method_btn, {
                            "payment-method": item,
                            round: "",
                            flat: "",
                            onUpdated: ($event: any) => (_ctx.onUpdated(item, $event))
                          }, null, 8, ["payment-method", "onUpdated"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_delete_payment_method_btn, {
                            "payment-method": item,
                            round: "",
                            flat: "",
                            onDeleted: ($event: any) => (_ctx.remove(item))
                          }, null, 8, ["payment-method", "onDeleted"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["payment-method"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}